import React from "react";

// TODO ui, context

function NearbyTreasureCountCard({ count }) {
  if (typeof count !== "number") return null;
  if (count === 0) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 65,
        right: 10,
        zIndex: 9999,
        background: "#fffbe6",
        border: "2px solid #c47f2b",
        borderRadius: 12,
        boxShadow: "0 2px 8px rgba(196,127,43,0.15)",
        padding: "12px 20px",
        minWidth: 120,
        fontFamily: "Segoe UI",
        color: "#c47f2b",
        fontWeight: "bold",
        fontSize: 18,
        display: "flex",
        alignItems: "center",
        gap: 10,
      }}
    >
      <img src="/treasure.svg" alt="寶藏" style={{ width: 28, height: 28 }} />
      附近寶藏：{count} 個
    </div>
  );
}

export default NearbyTreasureCountCard;
